import "./PortfolioImpactComponent.scss";

export const PortfolioImpact = "portfolioImpact";

export function portfolioImpact() {
    return {
        templateUrl: "app/portfolio/templates/ticket/place-order-wizard/steps/confirm/portfolio-impact/PortfolioImpactComponent.html",
        bindings: {
            totalPremium: "<",
            changeInMargin: "<",
            cashAfterTrade: "<",
            currentBalance: "<",
            feesAndBrokerage: "<",
            tradeFees: "<",
            totalCost: "<"
        },
        controllerAs: "ctrl",
        controller: () => {} // Dummy controller as there is no logic in there
    };
}
